module.exports = __webpack_public_path__ + "img/banner@2x.439490dc.png";